var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col, Button } from "@folio/stripes/components";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { RecekTextField } from "./inputs";
import css from "./CollectionFields.module.css";
export var CollectionOtherLanguageNamesFields = function () {
    var _a = useFormContext(), control = _a.control, errors = _a.formState.errors;
    var _b = useFieldArray({
        control: control,
        name: "otherLanguageNames",
    }), fields = _b.fields, append = _b.append, remove = _b.remove;
    return (React.createElement(React.Fragment, null,
        fields.map(function (item, index) { return (React.createElement(Row, { key: item.id },
            React.createElement(Col, { xs: 10 },
                React.createElement(Controller, { control: control, name: "otherLanguageNames.".concat(index, ".name"), render: function (_a) {
                        var _b, _c;
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.collections.otherLanguageNames.name.field.label", error: errors.otherLanguageNames &&
                                ((_c = (_b = errors.otherLanguageNames[index]) === null || _b === void 0 ? void 0 : _b.name) === null || _c === void 0 ? void 0 : _c.message) })));
                    } })),
            React.createElement(Col, { xs: 2, className: css.fieldButtonCol },
                React.createElement(Button, { buttonStyle: "danger", marginBottom0: true, onClick: function () { return remove(index); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" }))))); }),
        React.createElement(Button, { onClick: function () { return append({ id: "", name: "" }); } },
            React.createElement(FormattedMessage, { id: "ui-br-agency.collections.otherLanguageNames.name.button.label" }))));
};
